import { Outlet } from "react-router-dom";
import Sidebar, { SidebarContext } from "../components/dashboard/Sidebar";
import Navbar from "../components/dashboard/Navbar";
import { useState, type ReactNode } from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { AdminDashboardProvider } from "../context/AdminDashboardContext";

const drawerWidth = 230;
const collapsedDrawerWidth = 65;

interface AdminLayoutProps {
  children?: ReactNode;
}

const AdminLayout = ({ children }: AdminLayoutProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });
  const [desktopOpen, setDesktopOpen] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);
  const userType = localStorage.getItem("userType");

  const open = isMobile ? mobileOpen : desktopOpen;

  const toggleSidebar = () => {
    if (isMobile) {
      setMobileOpen((prev) => !prev);
    } else {
      setDesktopOpen((prev) => !prev);
    }
  };

  const closeSidebar = () => {
    if (isMobile) {
      setMobileOpen(false);
    } else {
      setDesktopOpen(false);
    }
  };

  const sidebarValue = {
    open,
    toggleSidebar,
    closeSidebar,
    drawerWidth,
    isMobile,
  };

  return (
    <AdminDashboardProvider>
      <SidebarContext.Provider value={sidebarValue}>
        <Box sx={{ display: "flex", width: "100%" }}>
          <Sidebar userType={userType} />
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              minWidth: 0,
              transition: (theme) =>
                theme.transitions.create(["margin", "width"], {
                  easing: theme.transitions.easing.sharp,
                  duration: theme.transitions.duration.enteringScreen,
                }),
              width: isMobile
                ? "100%"
                : `calc(100% - ${open ? drawerWidth : collapsedDrawerWidth}px)`,
              overflowX: "hidden",
            }}
          >
            <Navbar />
            <Box sx={{ padding: { xs: "12px", md: "20px" }, maxWidth: "100%", minWidth: 0 }}>
              {children || <Outlet />}
            </Box>
          </Box>
        </Box>
      </SidebarContext.Provider>
    </AdminDashboardProvider>
  );
};

export default AdminLayout;
